import { Gradients } from '@/shared/components/theme/gradient';
import { TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';
import { cn } from '@/shared/utils/cn';

type TabelHeaderProps = {
  columns: string[];
  columnWidths?: string[];
  withContainer?: boolean;
};

export const CustomTableHeader = ({
  columns,
  columnWidths,
  withContainer,
}: TabelHeaderProps) => {
  return (
    <TableHeader
      className={cn(
        'mb-2 flex flex-row active:bg-transparent',
        withContainer && 'rounded-2xl p-2',
      )}
    >
      <TableRow className="flex flex-1 flex-row border-b-transparent hover:bg-transparent">
        {columns.map((column, index) => (
          <TableHeaderCell
            key={column}
            child={<span className="w-max">{column}</span>}
            isLeftMost={index == 0}
            isRightMost={index == columns.length - 1}
            width={columnWidths?.[index]}
          />
        ))}
      </TableRow>
    </TableHeader>
  );
};

type TableHeaderCellProps = {
  child: React.ReactNode;
  isLeftMost?: boolean;
  isRightMost?: boolean;
};

const TableHeaderCell = (props: TableHeaderCellProps & { width?: string }) => {
  const { child, isLeftMost, isRightMost, width } = props;
  return (
    <TableHead
      className={cn(
        'flex items-center rounded-xs border-y border-white/40 px-4 py-3 text-start text-xs text-white',
        width || 'flex-1', // Use custom width if provided, else use flex-1
        isLeftMost && 'border-l',
        isRightMost
          ? `border-r ${Gradients.purpleBlueHeaderGradient} bg-gradient-to-r`
          : 'bg-[rgba(130,10,221,0.80)]',
      )}
    >
      {child}
    </TableHead>
  );
};
